import './WhyDangol.css';

const WhyDangol = () => {
  return (
    <section id="why-dangol" className="why-dangol">

      <div className="why-dangol-container">

        <div className="why-dangol-text reveal">
          <span className="eyebrow">Why we're called Dangol</span>
          <div className="korean-character" aria-hidden="true">단골</div>
          <h2 className="why-dangol-title display">
            Built around the idea<br />
            <em>of a regular.</em>
          </h2>
          <p className="why-dangol-body">
            <span className="korean-text">단골</span> ("dangol") is the Korean word for a regular —
            someone who keeps coming back to the places they love. Every shop has a few.
            The best shops are built on them.
          </p>
          <p className="why-dangol-body">
            Dangol is the simplest tool to identify, appreciate, and grow your community
            of regulars — the people who quietly keep your shop alive.
          </p>
        </div>

      </div>
    </section>
  );
};

export default WhyDangol;
